module.exports = __webpack_public_path__ + "static/media/10942568_10205663198159761_8009698667619759378_o.a713788a.jpg";